import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.42 1.205a.7.7 0 0 0-.99 0L6.812 3.823l-1.58-1.58a.7.7 0 0 0-.99.99l1.58 1.58L3.206 7.43a.7.7 0 0 0 0 .99l6.225 6.225a.7.7 0 0 0 .99 0l6.225-6.225a.7.7 0 0 0 0-.99zm-5.73 6.72 2.122-2.123 1.039 1.039-.001.046a1.037 1.037 0 1 0 .991-1.036L7.802 4.813 9.925 2.69l5.235 5.235-5.235 5.235zm14.21 7.652c0 .56-.585 1.323-1.712 1.323s-1.713-.762-1.713-1.323c0-.252.18-.78.657-1.535.32-.507.703-1.006 1.055-1.431.353.425.736.924 1.056 1.431.477.754.657 1.283.657 1.535m1.4 0c0 1.504-1.393 2.723-3.113 2.723s-3.112-1.22-3.112-2.723c0-1.359 1.518-3.287 2.434-4.326a.897.897 0 0 1 1.357 0c.916 1.04 2.434 2.967 2.434 4.326",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=BackgroundColorIcon24.js.map